import { createClient } from '@connectrpc/connect'
import type {
  GenerateReviewResponse,
  GetReviewFormConfigResponse,
} from '@customer/gen_proto/api_proto/v1/customer_review_service_pb'
import { CustomerReviewService } from '@customer/gen_proto/api_proto/v1/customer_review_service_pb'
import { reviewTransport } from '@customer/request/client'

/**
 * 施主向け口コミ作成サービスのクライアント。
 * share link token を注入しない `reviewTransport` を使う（無認証エンドポイント）。
 */
export const reviewClient = createClient(CustomerReviewService, reviewTransport)

/** アンケートフォーム設定取得のレスポンス型 */
export type ReviewFormConfigResult = GetReviewFormConfigResponse

/** 口コミ生成のレスポンス型 */
export type GenerateReviewResult = GenerateReviewResponse
